import { Link } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';

function ExtInteriorRemodels() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(/images/remodel_collage.jpg)' }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Exterior & Interior <span className="text-gold">Remodels</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Complete renovation and remodeling services for commercial properties
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
            <p>
              Williams Diversified specializes in comprehensive exterior and interior remodeling projects that breathe new life into existing structures. Whether you're updating a commercial facility, renovating office spaces, or modernizing building exteriors, we deliver transformative results that enhance both aesthetics and functionality.
            </p>
            <p>
              Our remodeling services combine creative design solutions with expert craftsmanship and project management. We handle every aspect of the renovation process, from initial planning and permits through final inspections, ensuring minimal disruption to your operations while delivering exceptional results.
            </p>
            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Our Remodeling Services</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Complete interior renovations and space reconfiguration</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Exterior facade modernization and upgrades</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Office and commercial space remodels</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Retail and hospitality renovations</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Building system upgrades and modernization</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>ADA compliance and accessibility improvements</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Energy efficiency upgrades</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Transform Your <span className="text-gold">Space</span></h3>
          <p className="text-gray-300 text-xl mb-10">
            Ready to modernize and revitalize your facility?
          </p>
          <Link to="/contact" className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default ExtInteriorRemodels;
